import { render, staticRenderFns } from "./RevertCert.vue?vue&type=template&id=0724456e&"
import script from "./RevertCert.vue?vue&type=script&lang=js&"
export * from "./RevertCert.vue?vue&type=script&lang=js&"
import style0 from "./RevertCert.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports